import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=2381511c"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=2381511c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports